import React from 'react';
import { Button } from '../Button/Button';
import { IconProps } from '../../icons';
import './NavigationItem.css';

export interface NavigationItemProps {
  children: React.ReactNode;
  leadingVisual?: IconProps['name'] | React.ReactNode;
  href?: string;
  onClick?: () => void;
  isActive?: boolean;
  variant?: 'primary' | 'secondary' | 'transparent' | 'link';
  disabled?: boolean;
  className?: string;
}

export const NavigationItem = React.memo(function NavigationItem({
  children,
  leadingVisual,
  href,
  onClick,
  isActive = false,
  variant = 'transparent',
  disabled = false,
  className = '',
}: NavigationItemProps) {
  const itemClassName =
    `navigation-item ${isActive ? 'navigation-item--active' : ''} ${className}`.trim();

  const buttonProps = {
    variant,
    leadingVisual,
    disabled,
    ...(href ? { as: 'a', href } : { onClick }),
  };

  return (
    <li className={itemClassName}>
      <Button {...buttonProps}>{children}</Button>
    </li>
  );
});
